// Player is always Tailos mint. Bots get one of these so they're easy to tell apart.
export const PLAYER_ACCENT = "#6fd6c8";

export const BOT_ACCENTS = [
  "#ff6b6b", // coral
  "#ffb454", // amber
  "#ffe066", // gold
  "#9aff8a", // lime
  "#7ad9ff", // sky
  "#b794ff", // violet
  "#ff8ad9", // pink
  "#ff5e3a", // tomato
];

const BOT_NAME_POOL = [
  "DustDevil",
  "Suctionator",
  "VacQueen",
  "BagLord",
  "FuzzHunter",
  "Roomba2",
  "Hooverbot",
  "Crumbcrusher",
  "Suds",
  "TidyKong",
  "Lintmaster",
  "Brushwell",
  "Filterius",
  "Whirlwind",
];

let _nameIdx = 0;
export function nextBotName(): string {
  const n = BOT_NAME_POOL[_nameIdx % BOT_NAME_POOL.length];
  _nameIdx++;
  return n;
}
